import { makeStyles } from '@material-ui/core';
import React from 'react';
import { ReactComponent as Cross } from '../../../img/cross.svg';
import { buttonConfig } from '../../Button';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        background: 'rgba(0,0,0,.2)',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    wrap: {
        background: '#FFF',
        padding: '10px 23px 25px 23px',
        width: 294,
        height: 165,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        rowGap: "15px"
    },
    header: {
        paddingBottom: 9,
        borderBottom: '1px solid #EAEAEF',
        display: 'flex',
        justifyContent: 'space-between'
    },
    header_title: {
        color: '#0D183F',
        fontFamily: 'Figtree, sans-serif',
        fontSize: 16,
        fontWeight: 700,
    },
    cross: {
        cursor: 'pointer'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
    },
    description: {
        color: "#0D183F",
        fontFamily: "Figtree, sans-serif",
        fontSize: 14,
        fontWeight: 400,
    },
    footer: {
        display: 'flex',
        gap: "20px"
    }
}));

const ModalTemplate = ({
    title,
    description,
    content,
    actionBar = [],
    ...props
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.wrap}>
                <div className={classes.header}>
                    <span className={classes.header_title}>{title}</span>
                    <Cross className={classes.cross} onClick={props.handleCancel} />
                </div>
                <div className={classes.content}>
                    <div>
                        <span className={classes.description}>{description}</span>
                    </div>

                    {content}

                    <div className={classes.footer}>
                        {actionBar.map(item => {
                            const btn = buttonConfig[item];
                            const Component = btn.component;   

                            return (
                                <Component handleClick={props[`handle${btn.action}`]} />
                            )
                        })}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalTemplate